module["exports"] = [];


/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/id_ID/name/prefix.js
 ** module id = 664
 ** module chunks = 0
 **/